export function getToken() {
  const token = {
    accessToken: '',
    idToken: ''
  };

  function safeParse(value) {
    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  }

  for (let i = 0; i < localStorage.length; i++) {
    const storageKey = localStorage.key(i);
    const rawValue = localStorage.getItem(storageKey);
    const parsed = safeParse(rawValue);

    if (!parsed) continue;

    if (parsed.credentialType === 'AccessToken') {
      token.accessToken = parsed.secret?.toString();
    }

    if (parsed.credentialType === 'IdToken') {
      token.idToken = parsed.secret?.toString();
    }

    // ✅ Break early if both tokens found
    if (token.accessToken && token.idToken) {
      break;
    }
  }

  return token;
}
